// ##############################
// // // Sidebar styles
// #############################

import { boxShadow, CSS_HOVER_FOCUS_PSEUDO_CLASSES, CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES, dangerColor, defaultFont, drawerMiniWidth, drawerWidth, EASE_TRANSITION, infoColor, primaryBoxShadow, primaryColor, roseColor, successColor, transition, warningColor } from "@hlcr/mui/theme/material-dashboard-pro/jss/material-dashboard-pro-react";
import { COLOR_SECONDARY } from "@hlcr/mui/theme/hacking-lab.theme";

const TRANSLATE_LEFT = "translate3d(-25px, 0, 0)";
const GREY_BG = "rgba(200, 200, 200, 0.2)";
const TEXT_TRANSITION = "transform 150ms ease 0s, opacity 150ms ease 0s";

const sidebarStyle = theme => ({
	...getDrawerStyles(theme),
	...backgroundStyles,
	...logoStyles,

	list: {
		marginTop: "15px",
		paddingLeft: "0",
		paddingTop: "0",
		paddingBottom: "0",
		marginBottom: "0",
		listStyle: "none",
		color: "inherit",
		"&:before,&:after": {
			display: "table",
			content: "\" \""
		},
		"&:after": { clear: "both" }
	},
	...itemStyles,
	...collapseStyles,
	...caretStyles,
	...colorStyles,
	sidebarWrapper: {
		position: "relative",
		overflowY: "auto",
		overflowX: "hidden",
		width: "260px",
		zIndex: "4",
		overflowScrolling: "touch",
		transitionProperty: "top, bottom, width",
		transitionDuration: ".2s, .2s, .35s",
		transitionTimingFunction: "linear, linear, ease",
		color: "inherit",
		paddingBottom: "30px",
		flex: "1 1 auto"
	},
	sidebarWrapperWithPerfectScrollbar: {
		overflowX: "hidden !important",
		overflowY: "hidden !important"
	},
	...userStyles,
	sideBarfaIcon: { fontSize: "24px" }
});

const getDrawerStyles = theme => ({
	drawerPaperRTL: {
		[theme.breakpoints.up("md")]: {
			left: "auto !important",
			right: "0 !important"
		},
		[theme.breakpoints.down("sm")]: {
			left: "0  !important",
			right: "auto !important"
		}
	},
	drawerPaper: {
		border: "none",
		position: "fixed",
		display: "flex",
		flexDirection: "column",
		top: "0",
		bottom: "0",
		left: "0",
		zIndex: "1032",
		transitionProperty: "top, bottom, width",
		transitionDuration: ".2s, .2s, .35s",
		transitionTimingFunction: "linear, linear, ease",
		// overflow: 'auto',
		overflowX: "hidden",
		...boxShadow,
		width: drawerWidth,
		[theme.breakpoints.up("md")]: {
			width: drawerWidth,
			position: "fixed",
			height: "100%"
		},
		[theme.breakpoints.down("sm")]: {
			width: drawerWidth,
			...boxShadow,
			position: "fixed",
			display: "flex",
			top: "0",
			height: "100vh",
			right: "auto",
			left: "0",
			zIndex: "1032",
			visibility: "visible",
			overflowY: "visible",
			borderTop: "none",
			textAlign: "left",
			paddingRight: "0px",
			paddingLeft: "0",
			transform: "translate3d(0px, 0, 0)",
			...transition
		},
		"&:before,&:after": {
			position: "absolute",
			zIndex: "3",
			width: "100%",
			height: "100%",
			content: "\"\"",
			display: "flex",
			top: "0"
		}
	},
	drawerPaperMini: { width: drawerMiniWidth + "px!important" }
});

const backgroundStyles = {
	blackBackground: {
		color: "#FFFFFF",
		"&:after": {
			background: "#000",
			opacity: ".8"
		}
	},
	secondaryBackground: {
		color: '#FFFFFF',
		'&:after': {
			background: COLOR_SECONDARY,
		}
	},
	blueBackground: {
		color: "#FFFFFF",
		"&:after": {
			background: "#00acc1",
			opacity: ".93"
		}
	},
	whiteBackground: {
		color: "#3C4858",
		"&:after": {
			background: "#FFFFFF",
			opacity: ".93"
		}
	},
	whiteAfter: { "&:after": { backgroundColor: "hsla(0,0%,71%,.3) !important" } },
	background: {
		position: "absolute",
		zIndex: "1",
		height: "100%",
		width: "100%",
		display: "block",
		top: "0",
		left: "0",
		backgroundSize: "cover",
		backgroundPosition: "center center",
		transition: EASE_TRANSITION
	}
};

const colorStyles = {
	purple: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: primaryColor,
			...primaryBoxShadow
		}
	},
	blue: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: infoColor,
			boxShadow:
				"0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)"
		}
	},
	green: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: successColor,
			boxShadow:
				"0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)"
		}
	},
	orange: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: warningColor,
			boxShadow:
				"0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)"
		}
	},
	red: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: dangerColor,
			boxShadow:
				"0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)"
		}
	},
	white: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#3C4858",
			backgroundColor: "#FFFFFF",
			boxShadow:
				"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(60,72,88,.4)"
		}
	},
	rose: {
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: {
			color: "#FFFFFF",
			backgroundColor: roseColor,
			boxShadow:
				"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(233,30,99,.4)"
		}
	}
};
const logoStyles = {
	logo: {
		padding: "15px 0px",
		margin: "0",
		display: "block",
		position: "relative",
		zIndex: "4",
		flexShrink: "0"
	},
	logoMini: {
		transition: EASE_TRANSITION,
		opacity: 1,
		float: "left",
		textAlign: "center",
		width: "30px",
		display: "inline-block",
		marginLeft: "22px",
		marginRight: "18px",
		marginTop: "7px",
		color: "inherit"
	},
	logoMiniRTL: {
		float: "right",
		marginRight: "30px",
		marginLeft: "26px"
	},
	logoNormal: {
		...defaultFont,
		transition: EASE_TRANSITION,
		display: "block",
		opacity: "1",
		transform: "translate3d(0px, 0, 0)",
		textTransform: "uppercase",
		padding: "5px 0px",
		fontSize: "18px",
		whiteSpace: "nowrap",
		fontWeight: "400",
		lineHeight: "30px",
		overflow: "hidden",
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: { color: "inherit" }
	},
	logoNormalRTL: { textAlign: "right" },
	logoNormalSidebarMini: {
		opacity: "0",
		transform: TRANSLATE_LEFT
	},
	logoNormalSidebarMiniRTL: { transform: TRANSLATE_LEFT },
	img: {
		maxWidth: "100%",
		verticalAlign: "middle",
		border: "0"
	},
	imgContainer: { padding: "0 15px" },
	imgMini: { maxHeight: 70 }
};

const itemStyles = {
	item: {
		color: "inherit",
		position: "relative",
		display: "block",
		textDecoration: "none",
		margin: "0",
		padding: "0"
	},
	itemLink: {
		cursor: "pointer",
		paddingLeft: "10px",
		paddingRight: "10px",
		transition: EASE_TRANSITION,
		margin: "10px 15px 0",
		borderRadius: "3px",
		position: "relative",
		display: "block",
		padding: "10px 15px",
		backgroundColor: "transparent",
		...defaultFont,
		width: "auto",
		"&:hover": {
			outline: "none",
			backgroundColor: GREY_BG,
			boxShadow: "none"
		},
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: { color: "inherit" }
	},
	username: {
		display: "inline-block",
		textOverflow: "ellipsis",
		maxWidth: 150,
		overflow: "hidden"
	},
	miniText: {
		width: "30px",
		marginRight: "15px",
		alignSelf: "center",
		lineHeight: "24px"
	},
	itemIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "inherit",
		width: "30px",
		minWidth: "inherit",
		height: "24px",
		float: "left",
		position: "inherit",
		top: "3px",
		marginRight: "15px",
		textAlign: "center",
		verticalAlign: "middle",
		opacity: "0.8"
	},
	itemIconRTL: {
		float: "right",
		marginLeft: "15px",
		marginRight: "1px"
	},
	itemText: {
		color: "inherit",
		...defaultFont,
		margin: "0",
		lineHeight: "30px",
		fontSize: "14px",
		transform: "translate3d(0px, 0, 0)",
		opacity: "1",
		transition: TEXT_TRANSITION,
		position: "relative",
		display: "block",
		height: "auto",
		whiteSpace: "nowrap"
	},
	itemTextRTL: {
		marginRight: "45px",
		textAlign: "right"
	},
	itemTextMini: {
		transform: TRANSLATE_LEFT,
		opacity: "0"
	},
	itemTextMiniRTL: { transform: TRANSLATE_LEFT + " !important" }
};

const caretStyles = {
	caret: {
		marginTop: "13px",
		position: "absolute",
		right: "18px",
		transition: "all 150ms ease-in",
		display: "inline-block",
		width: "0",
		height: "0",
		marginLeft: "2px",
		verticalAlign: "middle",
		borderTop: "4px solid",
		borderRight: "4px solid transparent",
		borderLeft: "4px solid transparent"
	},
	userCaret: { marginTop: "10px" },
	caretRTL: {
		left: "11px",
		right: "auto"
	},
	caretActive: { transform: "rotate(180deg)" }
};

const collapseStyles = {
	collapseList: { marginTop: "0" },
	collapseItem: {
		position: "relative",
		display: "block",
		textDecoration: "none",
		margin: "10px 0 0 0",
		padding: "0 0 0 12px !important"
	},
	collapseActive: {
		outline: "none",
		backgroundColor: GREY_BG,
		boxShadow: "none"
	},
	collapseItemLink: {
		transition: EASE_TRANSITION,
		margin: "0 15px",
		borderRadius: "3px",
		position: "relative",
		display: "block",
		padding: "10px",
		backgroundColor: "transparent",
		...defaultFont,
		width: "auto",
		"&:hover": {
			outline: "none",
			backgroundColor: GREY_BG,
			boxShadow: "none"
		},
		[CSS_SELF_HOVER_FOCUS_PSEUDO_CLASSES]: { color: "inherit" }
	},
	collapseItemMini: {
		color: "inherit",
		...defaultFont,
		textTransform: "uppercase",
		width: "30px",
		marginRight: "15px",
		textAlign: "center",
		letterSpacing: "1px",
		position: "relative",
		float: "left",
		display: "inherit",
		transition: TEXT_TRANSITION,
		fontSize: "14px"
	},
	collapseItemMiniRTL: {
		float: "right",
		marginLeft: "30px",
		marginRight: "1px"
	},
	collapseItemText: {
		color: "inherit",
		...defaultFont,
		margin: "0",
		position: "relative",
		transform: "translateX(0px)",
		opacity: "1",
		whiteSpace: "nowrap",
		display: "block",
		transition: TEXT_TRANSITION,
		fontSize: "14px"
	},
	collapseItemTextRTL: { textAlign: "right" },
	collapseItemTextMiniRTL: { transform: TRANSLATE_LEFT + " !important" },
	collapseItemTextMini: {
		transform: TRANSLATE_LEFT,
		opacity: "0"
	}
};

const userStyles = {
	user: {
		paddingBottom: "20px",
		margin: "20px auto 0",
		position: "relative",
		"&:after": {
			content: "\"\"",
			position: "absolute",
			bottom: "0",
			right: "15px",
			height: "1px",
			width: "calc(100% - 30px)",
			backgroundColor: "hsla(0,0%,100%,.2)"
		}
	},
	userItem: { "&:last-child": { paddingBottom: "0px" } },
	userItemText: { lineHeight: "22px" },
	photo: {
		transition: EASE_TRANSITION,
		width: "34px",
		height: "34px",
		float: "left",
		zIndex: "5",
		marginRight: "11px",
		borderRadius: "50%",
		marginLeft: "23px"
	},
	photoRTL: {
		float: "right",
		marginLeft: "12px",
		marginRight: "24px"
	},
	avatarIcon: {
		height: 34,
		width: 34
	},
	userCollapseButton: {
		margin: "0",
		padding: "6px 15px",
		"&:hover": { background: "none" }
	},
	userCollapseLinks: {
		marginTop: "-4px",
		[CSS_HOVER_FOCUS_PSEUDO_CLASSES]: { color: "#FFFFFF" }
	}
};

export default sidebarStyle;
